export default __webpack_public_path__ + "static/personalfundraise-3-de206f5907b99ef52a051faff3302284.png";